import React from 'react';

const GalleryOne = () => {
  return (
    <section className="gallery-one">
      <div className="gallery-one__carousel owl-theme owl-carousel">
        {/* Causes images */}
        <div className="item">
          <div className="gallery-one__single">
            <div className="gallery-one__img">
              <img src="assets/images/Hope-Spring-Water-Charity.jpg" alt="Clean water program" />
              <a href="project-details.html"><span className="fa fa-link"></span></a>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="gallery-one__single">
            <div className="gallery-one__img">
              <img src="assets/images/21.jpg" alt="Education support" />
              <a href="project-details.html"><span className="fa fa-link"></span></a>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="gallery-one__single">
            <div className="gallery-one__img">
              <img src="assets/images/affordable-healthcare.jpg" alt="Healthcare outreach" />
              <a href="project-details.html"><span className="fa fa-link"></span></a>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="gallery-one__single">
            <div className="gallery-one__img">
              <img src="assets/images/22.webp" alt="Emergency relief" />
              <a href="project-details.html"><span className="fa fa-link"></span></a>
            </div>
          </div>
        </div>

        {/* Additional images provided */}
        <div className="item">
          <div className="gallery-one__single">
            <div className="gallery-one__img">
              <img src="assets/images/1.jpg" alt="Gallery image 1" />
              <a href="project-details.html"><span className="fa fa-link"></span></a>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="gallery-one__single">
            <div className="gallery-one__img">
              <img src="assets/images/2.jpg" alt="Gallery image 2" />
              <a href="project-details.html"><span className="fa fa-link"></span></a>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="gallery-one__single">
            <div className="gallery-one__img">
              <img src="assets/images/3.webp" alt="Gallery image 3" />
              <a href="project-details.html"><span className="fa fa-link"></span></a>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="gallery-one__single">
            <div className="gallery-one__img">
              <img src="assets/images/7.webp" alt="Gallery image 7" />
              <a href="project-details.html"><span className="fa fa-link"></span></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GalleryOne;
